module.exports = __webpack_public_path__ + "img/578cd6895abf3d6cc704183f618592ab.png";